module.exports = __webpack_public_path__ + "img/cozy.414185a2.jpg";